<template>

  <div class="product-add mt30">
      <el-form-item label="供应商申请协议  ">
        <el-input v-model="form.license" type="textarea" rows="5" class="max-w460"></el-input>
      </el-form-item>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        loading: false,
      };
    },
    props:{
      form: Object,
    },
  };
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/plus/supply/setting/part/License.vue